
<template>
    <div v-if="showModal" class="maintenance-modal">
      <div class="modal-overlay" @click.prevent></div>
      <div class="modal-content" :class="{ 'en-version': lang == 'en' }">
        <div class="modal-header">
          <h2>{{ lang == 'en' ? '📢 Website Maintenance Notice' : '📢 网站维护通知' }}</h2>
        </div>
        <div class="modal-body">
          <p>{{ lang == 'en' ? 
            'To provide a better shopping experience, our website will undergo a system upgrade.' : 
            '为了提供更优质的购物体验，我们将进行系统升级。' }}</p>
          
          <p class="time-info">⏰ {{ lang == 'en' ? 
            'Scheduled Maintenance: May 17, 2025 at 12:00 AM – May 18, 2025 at 11:59 PM (Pacific Time, PT)' : 
            '维护时间：2025年5月17日 00:00 至 5月18日 23:59（北美太平洋时间，PT）' }}</p>
          
          <p>📌 {{ lang == 'en' ? 
            'The website will be temporarily unavailable during this period. We apologize for the inconvenience.' : 
            '维护期间网站将暂停访问，敬请谅解。' }}</p>
        </div>
        <div class="modal-footer">
          <p>{{ lang == 'en' ? 
            'Thank you for your understanding and continued support!' : 
            '感谢您的理解与支持！' }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MaintenanceModal',
    props: {
      showModal: Boolean,
      lang: String 
    },
  }
  </script>
  
  <style lang="less" scoped>
  .maintenance-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7); /* 主色调半透明遮罩 */
    z-index: 99999;
  }
  
  .modal-content {
    position: relative;
    z-index: 999999;
    width: 80%;
    max-width: 600px;
    padding: 30px;
    background: #fff9f9; /* 浅红色背景 */
    border: 2px solid rgb(204, 66, 61);
    border-radius: 10px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
    animation: fadeIn 0.3s ease-out;
  }
  
  .en-version {
    font-family: 'Arial', sans-serif;
  }
  
  .modal-header h2 {
    color: rgb(204, 66, 61); /* 主色调标题 */
    border-bottom: 1px solid rgba(204, 66, 61, 0.2);
    padding-bottom: 10px;
    font-size: 22px;
  }
  
  .modal-body {
    margin-bottom: 20px;
    line-height: 1.6;
  }
  
  .modal-body p {
    margin-bottom: 15px;
    font-size: 16px;
  }
  
  .time-info {
    color: rgb(204, 66, 61);
    background: rgba(204, 66, 61, 0.1);
    padding: 8px;
    border-radius: 4px;
  }
  
  .modal-footer {
    text-align: center;
    margin-top: 20px;
    font-style: italic;
    color: #7f8c8d;
    p {
        font-size: 16px;
    }
  }
  /* 英文版本微调 */
    .en-version .modal-header h2 {
        font-family: 'Arial', sans-serif;
        letter-spacing: 0.5px;
    }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  </style>
  